import { API_BASE } from "@/config/env";

// 读者端【修复版：自动带readerId + 完善鉴权】
export function readerFetch(url, opt = {}) {
  const token = localStorage.getItem("readerToken");
  const readerId = localStorage.getItem("readerId");
  
  const headers = {
    "Content-Type": "application/json",
  };
  if (!url.includes("/login")) {
    headers["X-Reader-Token"] = token || "";
  }

  // 开发环境走代理 /api，生产拼接域名
  let fullUrl;
  if (process.env.NODE_ENV === 'development') {
    fullUrl = url.startsWith("/") ? `/api/reader${url}` : `/api/reader/${url}`;
  } else {
    fullUrl = url.startsWith("/") ? `${API_BASE}/api/reader${url}` : `${API_BASE}/api/reader/${url}`;
  }

  // 核心修复：所有GET请求自动拼接 readerId 参数，解决后端鉴权报错
  if (opt.method === undefined || opt.method.toUpperCase() === "GET") {
    if(readerId){
      fullUrl += (fullUrl.includes("?") ? "&" : "?") + "readerId=" + readerId;
    }
  }

  let fetchOpt = {
    method: opt.method || "GET",
    headers,
    ...opt,
  };
  if (fetchOpt.method.toUpperCase() !== "GET" && opt.body) {
    fetchOpt.body = JSON.stringify(opt.body);
  } else {
    delete fetchOpt.body;
  }

  return fetch(fullUrl, fetchOpt).then(async (res) => {
    // 登录失效统一处理
    if (res.status === 401) {
      localStorage.removeItem("readerToken");
      localStorage.removeItem("readerId");
      location.hash = "/login";
      throw new Error("登录失效");
    }
    const data = await res.json();
    // 适配后端无效ID提示，强制掉线
    if(data.msg === "无效用户ID，请重新登录" || data.msg === "登录失效，请重新登录"){
      localStorage.removeItem("readerToken");
      localStorage.removeItem("readerId");
      location.hash = "/login";
      throw new Error("登录失效");
    }
    return data;
  });
}

export function loginFetch(body) {
  let loginUrl;
  if (process.env.NODE_ENV === 'development') {
    loginUrl = `/api/reader/login`;
  } else {
    loginUrl = `${API_BASE}/api/reader/login`;
  }
  return fetch(loginUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).then((res) => res.json());
}

export function uploadFile(url, formData) {
  const token = localStorage.getItem("readerToken");
  let uploadUrl;
  if (process.env.NODE_ENV === 'development') {
    uploadUrl = `/api/pub${url}`;
  } else {
    uploadUrl = `${API_BASE}/api/pub${url}`;
  }
  return fetch(uploadUrl, {
    method: "POST",
    headers: {
      "X-Reader-Token": token || "",
    },
    body: formData,
  }).then((res) => res.json());
}

// ========== 管理员请求函数 ==========
export function adminFetch(url, opt = {}) {
  const headers = {
    "Content-Type": "application/json",
  };

  // 管理接口统一走代理，生产环境自动拼接域名
  let fullUrl;
  if (process.env.NODE_ENV === 'development') {
    fullUrl = `/api/admin${url}`;
  } else {
    fullUrl = `${API_BASE}/api/admin${url}`;
  }

  let fetchOpt = {
    method: opt.method || "GET",
    headers,
    ...opt,
  };

  if (opt.body instanceof FormData) {
    delete fetchOpt.headers["Content-Type"];
  } else if (fetchOpt.method.toUpperCase() !== "GET" && opt.body) {
    fetchOpt.body = JSON.stringify(opt.body);
  } else {
    delete fetchOpt.body;
  }

  return fetch(fullUrl, fetchOpt).then(async (res) => {
    return res.json();
  });
}

export function adminLoginFetch(body) {
  let adminLoginUrl;
  if (process.env.NODE_ENV === 'development') {
    adminLoginUrl = `/api/admin/login`;
  } else {
    adminLoginUrl = `${API_BASE}/api/admin/login`;
  }
  return fetch(adminLoginUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).then((res) => res.json());
}

export function adminUploadFetch(url, formData) {
  const token = localStorage.getItem("adminToken");
  let uploadUrl;
  if (process.env.NODE_ENV === 'development') {
    uploadUrl = `/api/admin${url}`;
  } else {
    uploadUrl = `${API_BASE}/api/admin${url}`;
  }
  return fetch(uploadUrl, {
    method: "POST",
    headers: {
      "X-Admin-Token": token || "",
    },
    body: formData,
  }).then((res) => res.json());
}